import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";
import { FileText, Download, Loader2, AlertTriangle } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { toast } from "sonner";

const KIND = { assignment: "Ορισμός Δικαστή", composition: "Ορισμός Σύνθεσης", rapporteur: "Ορισμός Εισηγητή", reassignment: "ΑΝΑΧΡΕΩΣΗ" };

export default function MyTemplates() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState("");

  useEffect(() => {
    axios.get(`${API}/me/templates`).then(r => setData(r.data))
      .catch(e => setError(e.response?.data?.detail || "Σφάλμα φόρτωσης"));
  }, []);

  const download = async (t) => {
    try {
      setBusy(t.key);
      const r = await axios.get(`${API}/me/templates/${t.key}`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = t.file.split("/").pop(); a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Σφάλμα λήψης προτύπου"); }
    finally { setBusy(""); }
  };

  return (
    <div className="space-y-4 animate-fadeIn" data-testid="my-templates-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><FileText className="w-6 h-6 text-primary" />Πρότυπα</h1>
        <p className="text-slate-500 mt-1">Πρότυπα Πράξεων (DOCX) που χρησιμοποιεί το σύστημα για τους Τομείς σας. Οι Πράξεις εκδίδονται από τα Πινάκια / την Καρτέλα Υπόθεσης.</p>
      </div>
      {error && <p className="text-sm text-red-600 flex items-center gap-1" data-testid="my-templates-error"><AlertTriangle className="w-4 h-4" />{error}</p>}
      {!data && !error && <Loader2 className="w-6 h-6 animate-spin text-slate-400" />}
      {data && data.templates.length === 0 && (
        <Card><CardContent className="p-6 text-sm text-amber-800" data-testid="my-templates-empty">Δεν έχουν οριστεί Τομείς για τον λογαριασμό σας.</CardContent></Card>
      )}
      <div className="grid gap-3 md:grid-cols-2">
        {(data?.templates || []).map(t => (
          <Card key={t.key} data-testid={`template-card-${t.key}`}>
            <CardContent className="p-4 flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="font-medium text-slate-900">{t.title}</p>
                <div className="flex flex-wrap gap-1 mt-1">
                  <Badge variant="outline" className="text-[10px]">{KIND[t.kind] || t.kind}</Badge>
                  <Badge className={`text-[10px] ${t.court_type === "Μονομελές" ? "court-mono" : "court-poly"}`}>{t.court_type}</Badge>
                  {!t.available && <Badge className="text-[10px] bg-amber-500 text-white" data-testid={`template-missing-${t.key}`}>Δεν έχει παραδοθεί</Badge>}
                </div>
              </div>
              <Button size="sm" variant="outline" disabled={!t.available || busy === t.key} onClick={() => download(t)} data-testid={`template-download-${t.key}`}>
                {busy === t.key ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
      {(data?.pending || []).length > 0 && (
        <p className="text-xs text-slate-500" data-testid="my-templates-pending">Εκκρεμούν: {data.pending.join(" · ")}</p>
      )}
    </div>
  );
}
